export const env = {
  // baseUrl: 'http://localhost:3000',
  // baseUrl: 'https://api-dev.thetravelsquad.com',
  baseUrl: 'https://api-prod.thetravelsquad.com',
  // stripeKey: 'pk_test_51ND4JxJn4A96E1jlL74NMprywFWP5y1mxFdzqFAq2GlUbmnGYJQ4F2gEzkLs17Rr3KAkfzmD01e8hvKz6TPQJiaR00sY55Ep68',
  stripeKey: 'pk_live_51ND4JxJn4A96E1jlKKVCjDTrsv2Vll7CnSmrh5OzPtAdLiX7dfFvHzdwATItEDxYV6lX7NO1aVZ9xZHHGMNC3d6600LTnix0k6'
}
